
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { PromoTemplates } from "./PromoTemplates";
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';
import 'bootstrap/dist/css/bootstrap.min.css'

const PromoForm = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [promoId, setPromoId] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [template, setTemplate] = useState('standard');

    function handleSubmit() {
        //document.getElementById("editCampaignLink").click();
        console.log(name);
        console.log(startDate);
        let data = {"name": name,
            "promoId": promoId,
            "startDate": startDate,
            "endDate": endDate,
            "template": template
        }
        //console.log(pageTemplates);
        authFetch(instance, '/api/create_promo', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify(data),
        }).then(function(res) {
            return res.json();
        }).then(function(returnData) {
            data['promoDatabaseId'] = returnData['promoDatabaseId']
            console.log(data);
            navigate('/edit_promo', {state: data});
            //navigate('/edit_campaign', {state: {campaignId: data['campaignId'], name:`${campaignName}`, campaignStartDate:startDate, campaignEndDate:endDate, pages:pages, template:template, campaignProducts: {}}})
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    return (
        <Container className="text-start">
            <Row>
                <Col xs={6}>
                    <h2>Create New In Store Promotion</h2>
                </Col>
                <Col xs={2} className="text-end align-self-center offset-4 d-grid">
                    <Button
                        style={{
                            backgroundColor: "#a73c21",
                            color: "#ffffff",
                            textDecoration: "underline #a73c21",
                            borderRadius: "0px",
                            borderColor: "#a73c21"}}
                        onClick={() => navigate(-1)}>
                        Cancel
                    </Button>
                </Col>
                <hr/>
            </Row>

            {/* Form for creating new promotion */}
            <Row>
                <Form onSubmit={(event) => {event.preventDefault();}}>

                    {/* Promotion name field */}
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg={2} xs={4} className="text-start">Promotion Name:</Form.Label>
                        <Col xs={7}>
                            <Form.Control id="name" required={true} onChange={(e) => setName(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>

                    {/* Promotion ID field */}
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg={2} xs={4} className="text-start">Promotion ID:</Form.Label>
                        <Col xs={7}>
                            <Form.Control id="promoId" required={true} onChange={(e) => setPromoId(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>

                    {/* Promotion start date field */}
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg={2} xs={4} className="text-start">Start Date:</Form.Label>
                        <Col lg={2} xs={5}>
                            <Form.Control type="date" id="startDate" required={true} onChange={(e) => setStartDate(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>

                    {/* Promotion end date field */}
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg={2} xs={4} className="text-start">End Date:</Form.Label>
                        <Col lg={2} xs={5}>
                            <Form.Control type="date" id="endDate" required={true} onChange={(e) => setEndDate(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>

                    {/* Promotion template selector */}
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg={2} xs={4} className="text-start">Template:</Form.Label>
                        <Col lg={2} xs={5}>
                            <Form.Select id="template" onChange={(e) => setTemplate(e.target.value)}>
                                {PromoTemplates.map((templateOption) => <option value={templateOption.value} key={templateOption.name}>{templateOption.name}</option>)}
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    <br/>
                    <Col xs={3} className="text-start mb-3">
                        <button
                        onClick={() => handleSubmit()}
                        style={{}}>Submit</button>
                    </Col>
                </Form>
            </Row>
        </Container>
    )
}

export default PromoForm;